import { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { DonationTableQueryParamsProps } from '../DonationListTable/DonationListTable.types'

import { LocaleKey } from '@percent/partner-dashboard/i18n/config'
import { useAuthState } from '@percent/partner-dashboard/common/hooks'
import { PartnerScopes } from '@percent/partner-dashboard/constants/scopes'

type DonationKindOption = {
  label: string
  value: string
  text: LocaleKey
}

const donationKindOptions: DonationKindOption[] = [
  { label: 'Direct', value: 'direct', text: 'typography.donationType.direct' },
  { label: 'Matched', value: 'matched', text: 'typography.donationType.matched' },
  { label: 'On platform', value: 'hosted', text: 'typography.donationType.onPlatform' },
  { label: 'Off platform', value: 'external', text: 'typography.donationType.offPlatform' },
  { label: 'Wallet', value: 'wallet', text: 'typography.donationType.wallet' },
  { label: 'Payroll', value: 'payroll', text: 'typography.donationType.payroll' }
]

export const useDonationTypeFilter = ({ queryParams, setQueryParams }: DonationTableQueryParamsProps) => {
  const { t } = useTranslation()
  const { partner } = useAuthState()

  const hasPayrollScope = partner?.scopes?.some(data => data.scopeName === PartnerScopes.PayrollDonation)
  const hasWalletScope = partner?.scopes?.some(data => data.scopeName === PartnerScopes.DonationWallet)

  const onKindChange = useCallback(
    (kinds: string[]) => {
      setQueryParams({
        kinds
      })
    },
    [setQueryParams]
  )

  const filteredOptions = useMemo(() => {
    return donationKindOptions.filter(opt => {
      if (opt.value === 'payroll' && !hasPayrollScope) return false

      if (opt.value === 'wallet' && !hasWalletScope) return false

      return true
    })
  }, [hasPayrollScope, hasWalletScope])

  return {
    donationKindOptions: filteredOptions.map(opt => ({
      label: t(opt.text),
      value: opt.value
    })),
    onKindChange,
    selectedKinds: queryParams?.kinds?.filter((kind): kind is string => kind !== null) || []
  }
}
